import React from "react";
import { useField } from "formik";
import { FormControl, RadioGroup } from "@mui/material";
import { RadioProps } from "@mui/material/Radio";
import { RadioField, ValidationMessages } from "./index";
import { map } from "lodash";

type RadioOption = Record<string, string>;

export interface RadioGroupFormikProps
  extends Omit<RadioProps, "name" | "onChange" | "onBlur" | "error"> {
  name: string;
  options: { choices: RadioOption };
  status?: boolean;
  row?: boolean;
}

const RadioGroupFormik = ({
  name,
  status,
  options,
  row = true,
  ...props
}: RadioGroupFormikProps) => {
    const [field, meta] = useField(name);

    return (
      <FormControl fullWidth error={meta.touched && Boolean(meta.error)} component="fieldset">
        <RadioGroup row={row} {...field}>
          {map(options.choices, (value, option) => (
            <RadioField
              key={String(value)}
              name={field.name}
              label={option}
              value={String(value)}
              status={status}
              {...props}
            />
          ))}
        </RadioGroup>
        <ValidationMessages meta={meta} />
      </FormControl>
    )
};

export default RadioGroupFormik;
